import React from "react"

export default ({ title }) => (
  <div>
    {title && <h5>{title}</h5>}
    <h1>TBC</h1>
  </div>
)
